module.exports = __webpack_public_path__ + "static/img/staff.529e953.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/staff.png
// module id = Ozbk
// module chunks = 58